import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { getMyArticles, deleteMyArticle, resubmitMyArticle } from '../../api/pro';
import { PageHeader } from '../../components/layout/PageHeader';
import { DataTable } from '../../components/ui/DataTable';
import { StatusBadge } from '../../components/ui/StatusBadge';
import { useProEntry } from '../../contexts/ProEntryContext';
export default function ProArticleList() {
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const { activeEntryId } = useProEntry();
    const { data, isLoading } = useQuery({
        queryKey: ['my-articles', activeEntryId],
        queryFn: () => getMyArticles(activeEntryId),
        enabled: activeEntryId != null,
    });
    const deleteMut = useMutation({
        mutationFn: deleteMyArticle,
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['my-articles'] }),
    });
    const resubmitMut = useMutation({
        mutationFn: resubmitMyArticle,
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['my-articles'] }),
    });
    const columns = [
        { key: 'title', header: 'Titre', render: (a) => _jsx("span", { className: "font-medium", children: a.title }) },
        { key: 'status', header: 'Statut', render: (a) => _jsx(StatusBadge, { status: a.status }) },
        { key: 'created_at', header: 'Créé le', render: (a) => new Date(a.created_at).toLocaleDateString('fr-FR') },
        { key: 'actions', header: '', render: (a) => (_jsxs("div", { className: "flex gap-3 justify-end", children: [a.status === 'rejected' && _jsx("button", { onClick: (e) => { e.stopPropagation(); resubmitMut.mutate(a.id); }, disabled: resubmitMut.isPending, className: "text-xs text-blue-600 hover:text-blue-800 disabled:opacity-50", children: "Re-soumettre" }), _jsx("button", { onClick: (e) => { e.stopPropagation(); if (confirm('Supprimer ?'))
                            deleteMut.mutate(a.id); }, className: "text-xs text-red-500 hover:text-red-700", children: "Supprimer" })] })) },
    ];
    return (_jsxs(_Fragment, { children: [_jsx(PageHeader, { title: "Mes actualit\u00E9s", subtitle: `${data?.total ?? 0} actualité(s)`, actions: _jsx("button", { onClick: () => navigate('/pro/articles/new'), className: "px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700", children: "Nouvelle actualit\u00E9" }) }), _jsx(DataTable, { columns: columns, data: data?.data ?? [], isLoading: isLoading, onRowClick: (a) => navigate(`/pro/articles/${a.id}/edit`) })] }));
}
